<template>
  <div class="container">
    <el-row class="contenedor1"> 
      <el-col :span="8">
      <router-link :to="{ name: 'Alta Post'}">
              <el-button
                type="primary"
                icon="Plus"
                size="small"
                round
              >{{ $t('GENERAL_nuevo') }}</el-button>
            </router-link>
            </el-col>
          <el-col :span="14">
            <div class="filters_item">
                    <el-select clearable class="seleccionador" 
                      v-model="filtros.estado" 
                      size="small" 
                      @change="buscar"
                      :placeholder="$t('FORO_confirmado')"
                    >
                      <el-option :value="1" :label="$t('FORO_confirmado')"></el-option>
                      <el-option :value="2" :label="$t('FORO_archivado')"></el-option>
                  </el-select>
                </div>
          </el-col>
    </el-row>
    <!-- <div class="container_filters">
      <el-dropdown trigger="click">
        <el-button size="small" type="plain">
          Ver
          <el-icon><ArrowDown /></el-icon>
        </el-button>
        <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item>Action 1</el-dropdown-item>
          <el-dropdown-item>Action 2</el-dropdown-item>
          <el-dropdown-item>Action 3</el-dropdown-item>
          <el-dropdown-item>Action 4</el-dropdown-item>
          <el-dropdown-item>Action 5</el-dropdown-item>
        </el-dropdown-menu>
        </template>
      </el-dropdown>

      <el-dropdown trigger="click">
        <el-button size="small" type="plain">
          Ordenar por
          <el-icon><ArrowDown /></el-icon>
        </el-button>
        <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item>Action 1</el-dropdown-item>
          <el-dropdown-item>Action 2</el-dropdown-item>
          <el-dropdown-item>Action 3</el-dropdown-item>
          <el-dropdown-item>Action 4</el-dropdown-item>
          <el-dropdown-item>Action 5</el-dropdown-item>
        </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div> -->
    <el-row>
    <el-col :span="22" class="container_1">
      <div class="card_list">
            <div class="card card_list_item" v-for="post in posts" :key="post.id" >
              <ForoCard
              :post="post"
              @openPost="openPost"
              @archivar="archivar"/>
            </div>
          </div>  
          </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ForoCard from "@/components/Cards/foroCard";
import { showSuccess } from '../Mensaje';
import { mostrarMensajeInternacionalizado } from '../MensajeInternacionalizado'

let defaultFilters = {
    estado: 1,
};

export default {
  name: "ForoPanel",
  components: { ForoCard },
  data() {
    return {
      posts: [],
      filtros: { ...defaultFilters },
    };
  },
  computed: {
    ...mapState({
        idUsuario: state => state.sesion.resultadoAutenticacion.IdUsuario,
      })
    },
  methods: {
    buscar() {
      // armo el payload
      let payload;

      payload = { ...this.filtros };
      payload.idUsuario = this.idUsuario,
      payload.page = 0;
      payload.pageSize = 10;

      // busco las entradas de foro
      this.$store.dispatch('foro/getEntradasForo', payload)
      .then(data => { 
        this.posts = data.Result 
      })
    },
    openPost(id) {
      this.$router.push({ name: "Post", params: { id: id } });
    },
    archivar(id){
      this.save(id);
    },
    save(id) {
        this.$store.dispatch('foro/cambiarArchivado',  { id: id })
         .then(result => {
        if (result != 0)  mostrarMensajeInternacionalizado(
            result.CodigoResultado,
            result.DescripcionResultado
          );
        else showSuccess(this.$t("GENERAL_success"));
      })
      .finally(() => (this.buscar()));
    }
  },
  mounted() {
    //Scroll para Android
       document.body.scrollTop = 0;
       //Scroll para IOS
       document.documentElement.scrollTop = 0;
    this.buscar()
  }
};
</script>

<style scoped>
.container {
  text-align: left;
}
/* .posts {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 2px;
  grid-column-gap: 20px;
  grid-row-gap: 20px;
  max-width: 97%;
  margin-top: 20px; */
/* } */
.card_list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  /* grid-template-columns: repeat(auto-fit, minmax(320px, 1fr)); */
  grid-gap: 1rem;
}
.card_list_item {
  position: relative;
}
.card {
  cursor: pointer;
  /* transition: 0.2s all ease; */
}
  .filters_item{
    text-align: right;
  }
    .seleccionador{
    max-width: 130px;
  }
/* .card:hover {
  transform: translateY(-5px);
} */
  .container_1{
    padding: 50px;
  }
  .contenedor1{
    margin-right: 50px;
    margin-left: 50px;
  }
@media (max-width: 800px) {
  .container {
    flex-direction: column;
  }
  .container_1{
    padding: 0px;
    margin-top: 10px;
  }
  .contenedor1{
    margin-right: 0px;
    margin-left: 0px;
  }
  .card_list {
    grid-template-columns: 1fr;
  }

}
</style>

